import { useContext, useEffect, useRef, useState } from 'react'
import { Provider } from '../pages/useContext/MenuContext';
import { Footer } from '../components/layout/Footer';
import { Routes, Route, Outlet, redirect, useNavigate, useLocation } from 'react-router-dom';
import { checkDpSuccess, decodeJWT, handleSessionClear, setTokenInfo, tokenExpired, writeToken } from '../utility/service/tool-service';
import { auth, grantTypeEnum } from '../utility/service/token-Service';
import { AlertService } from '../utility/service/alert-service';
import { getAcConfEdition, getAcConfExpiryDate } from '../utility/service/tool-service';
import { useTranslation } from 'react-i18next';

import TopBar from './layout/TopBar';

import SideBar from './layout/SideBar';

import CloseBtn from '../assets/images/icons/ic-x.svg';
import { AuthContext } from '../components/AuthContext'
import { revocationToken } from '../utility/service/dgr-service';
import { AcctContext } from '../utility/useReduce/userNameReduce';
import AiLexiHelper from './AiLexiHelper';
import { initDataProp, updateUserLoginRecord } from '../utility/service/api-service';
import { getSupportedLanguage } from '../utility/languageUtils';

export default function MainLayout({ children }) {

  const [menuClick, setMenuClick] = useState(true);
  const [currentFunctionId, setCurrentFunctionId] = useState(true);
  const menuContext = {
    menuClick,
    setMenuClick,
    currentFunctionId,
    setCurrentFunctionId
  }

  // const _accessToken = sessionStorage.getItem('access_token');
  const [accessToken] = useState(sessionStorage.getItem('access_token'));
  const navigate = useNavigate();
  const location = useLocation();
  const edition = getAcConfEdition();
  const expiryDate = getAcConfExpiryDate();
  const [verCode, setVerCode] = useState('');
  const [versionInfo, setVersionInfo] = useState();
  const { t } = useTranslation();
  const sideMenuRef = useRef(null);
  const maskCloseRef = useRef(null);
  const [state, dispatchUser] = useContext(AcctContext); //訊息視窗 
  // const [showAi,setShowAi] = useState(false);

  // const [version,setVersion] = useState('');

  let themeColorSession = sessionStorage?.getItem("loadTheme") !== "undefined" && sessionStorage?.getItem("loadTheme") !== null ? sessionStorage?.getItem("loadTheme") : 'green';

  //   useEffect(() => {
  //     if (!accessToken) {
  //       /**
  //        * 無token 直接登出       
  //        */
  //       navigate("/login");
  //     }
  //     else {
  //       tokenExpired().then(expired => {
  //         if (expired) {
  //           // console.log('tokenExpired=>',expired);          
  //           auth('', '', grantTypeEnum.refresh_token).then(res => {
  //             // console.log('refresh token result,', res)

  //             if (checkDpSuccess(res)) {
  //               setTokenInfo(res.data);
  //               writeToken('access_token', res.data.access_token)
  //               writeToken('decode_token', JSON.stringify(decodeJWT(res.data.access_token)))
  //             }
  //             else {
  //               AlertService.ok(res.code, res.message);
  //               navigate('/login');
  //             }

  //           })
  //         }
  //       })
  //     }
  //     getCodeVersion().then((res) => { //取得版本資訊
  //       if (checkDpSuccess(res)) {
  //         setVerCode(res.data.RespBody.version);
  //         setVersionInfo(res.data.RespBody)
  //       }
  //     })
  //   }, []);

  //   useEffect(() => {
  //     if (versionInfo) {
  //       checkVersionExpired();
  //     }
  //   }, [versionInfo]);


  const simpleStyles = {
    content: {
      marginLeft: !menuClick ? 0 : 240,
      padding: 3,
    }
  }

  //控制桌機版ToBar sidebar-active 開關
  const handleSideBarActive = () => {
    if (sideMenuRef?.current.classList.contains("sidebar-active")) {
      sideMenuRef?.current?.classList?.remove('sidebar-active');
    } else {
      sideMenuRef?.current?.classList?.add('sidebar-active');
    }
  }
  //手機板ToBar 開關 
  const handleTopBarMobileClick = () => {
    if (maskCloseRef?.current.classList.contains("hidden")) {
      maskCloseRef?.current?.classList?.remove('hidden');
      sideMenuRef?.current?.classList?.add('mobile-sidebar-active');
    } else {
      maskCloseRef?.current?.classList?.add('hidden');
    }
  }

  //mask-close-btn hidden 開關()
  const handleMaskClose = () => {
    if (maskCloseRef?.current.classList.contains("hidden")) {
      maskCloseRef?.current?.classList?.remove('hidden');
    } else {
      maskCloseRef?.current?.classList?.add('hidden');
      sideMenuRef?.current?.classList?.remove('mobile-sidebar-active');
    }
  }

  //layoutMaskClick
  const handelLayoutMaskClick = () => {
    if (!maskCloseRef?.current.classList.contains("hidden")) {
      maskCloseRef?.current?.classList?.add('hidden');
      sideMenuRef?.current?.classList?.remove('mobile-sidebar-active');
    }
  }

  // useLayoutEffect(()=>{
  //   getCodeVersion()
  //     .then(res=>{
  //       if(res?.request?.status === 200 || res?.status === 200){
  //         setVersion(res?.data?.version);
  //       } 
  //     })
  // },[])  

    // const axios_initDataProp = ()=>{
    //   initDataProp({reqType:'aiChat'})
    //     .then((res)=>{
    //       if(checkDpSuccess(res)){
    //         let data = res?.data?.RespBody;
    //         let aiChat = data.aiChat==='N'?false:true;
    //         setShowAi(aiChat)
    //       }
          
    //     })
    // }

    useEffect(()=>{
      // axios_initDataProp();
    },[])


  return (
    <AuthContext>
      <Provider value={menuContext}>
        {/* 桌機版關閉左側選單，請移除 sidebar-active */}
        <div ref={sideMenuRef} id="sideBarMenu"
          className={`layout-container sidebar-active ${getSupportedLanguage()} ${themeColorSession}`}>
          <SideBar />
          <div className='layout-content-wrapper'>
            <TopBar
              topBarClick={() => { handleSideBarActive(); }}
              topBarMobileClick={() => { handleTopBarMobileClick(); }}
              handleLogout={() => {
                //註銷token access_token refresh_token
                updateUserLoginRecord({eventType:"LOGOUT"});
                revocationToken('access_token')
                  .then((res) => {
                    if (res?.status === 200) {
                      dispatchUser({ type: 'CLEAR_INFO' });
                      return revocationToken('refresh_token');
                    }
                  })
                  .then((res) => {
                    if (res?.status === 200) {
                      handleSessionClear();//不要將loadTheme刪除 系統設定的主題色
                      navigate("/login");
                      
                    }
                  })

              }}
            />

            {/* <div className='layout-breadcrumb'></div> */}
            <div className='layout-content'>
              <Outlet />
              
            </div>
            <Footer></Footer>
          </div>

          {/* 關閉遮罩，請移除 hidden */}
          <div onClick={() => { handelLayoutMaskClick() }} ref={maskCloseRef} className='layout-mask lg:hidden hidden'>
            <img
              className='mask-close-btn'
              src={CloseBtn}
              alt="關閉"
              onClick={() => { handleMaskClose(); }}
            />
          </div>
          {/* {
            showAi && <AiLexiHelper />
          } */}
          
        </div>
      </Provider>
    </AuthContext>

  )
}

